import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userschools',
  templateUrl: './userschools.component.html',
  styleUrls: ['./userschools.component.css']
})
export class UserschoolsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
